<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.position' clearable
                      :placeholder="$t('广告位置') " style='width:120px'>

                <Option :key="key" :value="value['id']"
                        v-for="(value, key) in positionParams"> {{ value['name'] }}
                </Option>
              </Select>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->

    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='标题' prop='title'>
          <Input clearable v-model='windowAddItem.title' :placeholder="$t('请输入标题')"></Input>
        </FormItem>
        <FormItem label="是否显示">
          <i-switch v-model="windowAddItem.isShow"
                    :true-value=1 :false-value=0 true-color="#13ce66"/>
        </FormItem>
        <FormItem label='跳转地址' prop='jumpUrl'>
          <Input clearable v-model='windowAddItem.jumpUrl' :placeholder="$t('请输入跳转地址')"></Input>
        </FormItem>
        <FormItem label="图片" prop="logo">

          <FormItem label='图片(链接)' prop='logo'>
            <Input clearable v-model='windowAddItem.imageUrl' :placeholder="$t('请输入图片的链接地址')"></Input>
          </FormItem>
          <div class="demo-upload-list" v-if="windowAddItem.imageUrl">
            <img :src="windowAddItem.imageUrl" style="max-width: 200px;max-height: 200px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove('imageUrl')"></Icon>
            </div>
          </div>
          <input v-if="windowAddItem.imageUrl" v-model="windowAddItem.imageUrl" type="hidden" name="image">
          <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.imageUrl"
                  :format="['jpg','jpeg','png','gif']" :max-size="5120"
                  :on-success="v=>{handleImgSuccess(v,'imageUrl')}"
                  :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>
        </FormItem>

        <FormItem  label='广告位置' class='margin-bottom-0'>
          <Select  v-model='windowAddItem.position' clearable
                  :placeholder="$t('广告位置') " style='width:120px'  @on-change="e=>changePosition(e)">

            <Option :key="key" :value="value['id']"
                    v-for="(value, key) in positionParams"> {{ value['name'] }}
            </Option>
          </Select>
        </FormItem>


        <FormItem label='所属彩种' class='margin-bottom-0' v-if="isShowChangeType||windowAddItem.position==4" >
          <Select v-model='windowAddItem.lotteryType' clearable
                  :placeholder="$t('所属彩种') " style='width:120px'>

            <Option :key="key" :value="value['lotteryType']"
                    v-for="(value, key) in lotteryParams"> {{ value['lotteryName'] }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label='排序' prop='showIndex'>
          <InputNumber :max="100" :min="0" :step="1"
                       v-model="windowAddItem.showIndex"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'

export default {
  name: 'interface_list',
  data() {
    return {
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: 'ID',
        key: 'id',
        width: 65,
        align: 'center'
      }, {
        title: '广告位置',
        key: 'positionName',
        width: 125,
        align: 'center'
      }, {
        title: '彩种类型',
        key: 'lotteryName',
        width: 125,
        align: 'center'
      }, {
        title: this.$t('标题'),
        key: 'title',
        minWidth: 120,
        align: 'center'
      }, {
        title: '图片',
        sortable: true,
        align: 'center',
        width: 250,
        render: (h, params) => {
          let vm = this
          return params.row.imageUrl.length>3?h('img', {
            attrs: {
              style: 'height:100px',
              src: params.row.imageUrl
            }
          }):''
        }
      }, {
        title: this.$t('跳转地址'),
        key: 'jumpUrl',
        minWidth: 120,
        align: 'center'
      }, {
        title: '是否显示',
        sortable: true,
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShow,
            },
            on: {
              'on-change': function (status) {
                customPost('tuku/AdManage', {op: 'show', id: params.row.id, isShow: status}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显示")
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.id = params.row.id;
                vm.windowAddItem.title = params.row.title;
                vm.windowAddItem.imageUrl = params.row.imageUrl;
                vm.windowAddItem.showIndex = params.row.showIndex;
                vm.windowAddItem.jumpUrl = params.row.jumpUrl;
                vm.windowAddItem.position=params.row.position;
                vm.windowAddItem.lotteryType=params.row.lotteryType;
                vm.windowAddItem.isShow = params.row.isShow;
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('tuku/AdManage', {op: 'del', id: params.row.id}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        imageUrl: ''
      },
      windowAddItemTemp: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------
      positionParams: {},
      lotteryParams: {},
      isShowChangeType:false
    }
  },
  created() {
    let vm = this
    customPost('tuku/AdManage', {op: 'getPositionNames'}).then(response => {
      vm.positionParams = response.data.data;
      this.getList()
    })

    customPost('tuku/AdManage', {op: 'getLotteryTypes'}).then(response => {
      vm.lotteryParams = response.data.data;

    })


  },
  mounted() {

  },
  methods: {
    changePosition(e){
      if(e==4){
        this.isShowChangeType=true
      }else{
        this.isShowChangeType=false
      }
      console.log( this.windowAddItem.position)
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page = vm.tableShow.currentPage
      vm.searchConf.size = vm.tableShow.pageSize
      customPost('tuku/AdManage', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id = 0;
      vm.windowAddItem.title = '';
      vm.windowAddItem.imageUrl = '';
      vm.windowAddItem.showIndex = 0;
      vm.windowAddItem.jumpUrl = '';
      vm.windowAddItem.position=1
      vm.windowAddItem.isShow = 1;
      vm.windowAdd.show = true
      this.isShowChangeType=false
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          Object.assign(vm.windowAddItemTemp, vm.windowAddItem) //浅复制数据params.row 给 vm.windowAddItemTemp
          vm.windowAddItemTemp.op = 'save';
          customPost('tuku/AdManage', vm.windowAddItemTemp).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
    handleImgFormatError(file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove(key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess(response, key) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        if (response.data.fileUrl.startsWith('http')) {
          this.windowAddItem[key] = response.data.fileUrl
          this.windowAddItemTemp[key] = response.data.fileUrl
        } else {
          this.windowAddItem[key] = response.data.showUrl
          this.windowAddItemTemp[key] = response.data.showUrl
          console.log(this.windowAddItem.js)
          this.$forceUpdate();
        }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
